import React from 'react';
import { useMemo, useRef } from 'react';
import client from '../../api/WookAxios';
import ReactQuill, { Quill } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { Navigate } from 'react-router-dom';
import QuillResizeImage from 'quill-resize-image';
import log from 'loglevel';

// console.log(Quill);
// console.log(QuillResizeImage);
// console.log(Quill.register);
// if (typeof window !== 'undefined' && window.Quill) {
//   window.Quill = Quill;
// }
// Quill.register('modules/resize', window.QuillResizeImage);
Quill.register('modules/resize', QuillResizeImage);
window.Quill = Quill;


const QuillEditor = ({ value, onChange, post }) => {
  const quillRef = useRef(null);

  const imageHandler = () => {
    console.log('wow');

    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.addEventListener('change', async () => {
      console.log('event change occur!');

      console.log('post', post);

      const formData = new FormData();
      formData.append('image', input.files[0]);

      try {
        const response = await client.uploadTemporaryImage(formData);
        log.debug('UPLOAD_TEMPORARY_IMAGE_SUCCESS', response);
        const imgUrl = response.data.image;
        const editor = quillRef.current.getEditor();
        const range = editor.getSelection();
        editor.insertEmbed(range.index, 'image', imgUrl);
        editor.setSelection(range.index + 1);
      } catch (e) {
        log.debug('UPLOAD_TEMPORARY_IMAGE_SAVE_FAILED', e);
      }
    });
  };

  const formats = [
    "size", "color", "background", "bold", "italic",
    "underline", "strike", "list",
    "image",
  ];

  const toolbarOptions = [
    [{ size: ["small", false, "large", "huge"] }],
    [{ color: [] }, { background: [] }],
    ["bold", "italic", "underline", "strike"],
    [
      { list: "ordered" },
    ],
    ["image"],
  ];

  const modules = useMemo(() => ({
    toolbar: {
      container: toolbarOptions,
      handlers: { image: imageHandler },
    },
    resize: {
      locale: {},
    },
  }), []);

  return (
    <div className="QuillEditor">
      <ReactQuill
        ref={quillRef}
        theme="snow"
        // placeholder="내용을 작성하세요..."
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
      />      
    </div>
  );

  // return (
  //   <div className="QuillEditor">
  //     <ReactQuill
  //       theme="snow"
  //       // placeholder="내용을 작성하세요..."
  //       value={value}
  //       onChange={onChange}
  //       modules={{
  //         toolbar: {
  //           container: toolbarOptions,
  //         }
  //       }}
  //       formats={formats}
  //     />      
  //   </div>
  // );
};

export default QuillEditor;